exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gauge-container{\n  margin-top:32px;\n  margin-left: 16px;\n}\n\n.gauges-charts{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.gauge-container > p{\n  font-weight: book;\n  font-size: 14px;\n  color:rgba(51,51,51,0.4);\n}\n\n.gauge-container > h2{\n  font-weight: bold;\n  font-size: 15px;\n  color:rgb(51,51,51);\n}\n", ""]);

// exports
